export default __webpack_public_path__ + "static/media/egg-fry.b703ff1b.mp3";